/**
 *
 * @Copyright 2024 UNLOCKIT DECENTRALIZATION, LDA
 * Development by VOID Software, SA
 *
 */

import { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';
import { TranslationContext, withTranslationContext } from '../../../controllers/TranslationContext';
import ElectronicIDLogo from '../../../../assets/images/logo-electronic-id.png';
import ElectronicIDIcon from '../../../../assets/images/electronic-logo-short.png';
import { EsignaturesLayout } from '../../../elements/esignatures/layouts/EsignaturesLayout';
import { EsignatureErrorModal } from '../../../elements/esignatures/common/EsignatureErrorModal';
import Button from '../../../elements/Button';
import { ButtonVariant } from '../../../../types/general';
import { QesSignatureContext, withQesSignatureContext } from '../../../controllers/esignatures/QesSignatureContext';

type OwnProps = TranslationContext & QesSignatureContext;

const QesSignatureVideoValidationFailedScreenComponent: FunctionComponent<OwnProps> = (props) => {
    const { t, navigateToContract, navigateToStartVideoValidation } = props;

    const { state } = useLocation();
    const { requirementsErrors = [] } = state;

    const retryButton = (
        <Button
            id="actionNext"
            variant={ButtonVariant.Curved}
            extraClasses="primary"
            testId="actionNext"
            onClick={navigateToStartVideoValidation}
        >
            {t('qesSignatureVideoValidationFailed.retryAction')}
        </Button>
    );

    const goBackSpan = (
        <span onClick={navigateToContract}>
            {t('qesSignatureVideoValidationFailed.goBackAction')}
        </span>
    );

    const errorDescriptions = (): string | string[] => {
        if (requirementsErrors.length > 0) {
            return requirementsErrors.map((e: string) => (t(`qesSignatureVideoValidationFailed.description.${e}`)));
        }

        return t('errors.general');
    };
    
    return (
        <div className="qes-signature-documents">
            <EsignaturesLayout>
                <div className="qes-signature-layout">
                    <div className="qes-signature-banner">
                        <img src={ElectronicIDLogo} alt="Electronic IDentification logo" height={25} width="auto" />
                    </div>
                    <EsignatureErrorModal
                        open
                        providerIconSrc={ElectronicIDIcon}
                        errorTitle={t('qesSignatureVideoValidationFailed.title')}
                        errorDescription={errorDescriptions()}
                        extraClasses="qes-signature-modal"
                        retryButton={retryButton}
                        tryAgainLaterBackButton={goBackSpan}
                    />
                </div>
            </EsignaturesLayout>
        </div>
    );
};

export const QesSignatureVideoValidationFailedScreen = withQesSignatureContext(withTranslationContext(QesSignatureVideoValidationFailedScreenComponent));
